import { useTranslation } from 'react-i18next';

import { Paragraph } from '@app/shared/ui/atoms/Common';
import { Cards } from '@app/shared/ui/molecules/Home';
import { Page } from '@app/routes';

export interface CognitionBannerProps {
  route: string;
  tKeyTitle: string;
  tKeyDescription: string;
  imgSrc: string;
}

export function CognitionBanner({
  route,
  tKeyTitle,
  tKeyDescription,
  imgSrc,
}: CognitionBannerProps) {
  const { t } = useTranslation();

  return (
    <div className="relative cursor-pointer overflow-hidden rounded-2xl bg-[linear-gradient(162.65deg,#0763BE_4.46%,#439DF7_88.1%)] p-[19px_14px]">
      <div className="absolute -left-[5px] -top-[18px] h-[114px] w-[386px] rounded-full bg-[linear-gradient(90deg,hsla(236,100%,44%,1),hsla(209,95%,51%,1),hsla(236,100%,44%,1))] opacity-80 blur-[21px]" />
      <Paragraph variant="white" className="relative z-10">
        {t(tKeyTitle)}
      </Paragraph>
      <Paragraph variant="white" className="relative z-10" size="2xs">
        {t(tKeyDescription)}
      </Paragraph>
      <img
        src={imgSrc}
        alt="Moon"
        className="absolute right-0 top-1/2 h-full -translate-y-1/2 mix-blend-lighten"
      />
      {route === Page.DAILY_CARD_DESCRIPTION && (
        <Cards
          className="right-[30%] top-1/2 h-full -translate-y-1/2"
          firstImageClassName="bg-cognition-accent-card w-[42px] h-[67px] top-8"
          secondIMageClassName="bg-cognition-question-card w-[41px] h-[62px] top-[30px] text-[34px] leading-none"
        />
      )}
    </div>
  );
}
